import { provideHttpClient } from "@angular/common/http";
import {
  enableProdMode,
  ErrorHandler,
  importProvidersFrom,
  isDevMode,
  provideExperimentalZonelessChangeDetection,
} from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { provideEffects } from "@ngrx/effects";
import { provideStore } from "@ngrx/store";
import { provideStoreDevtools } from "@ngrx/store-devtools";
import { MarkdownModule } from "ngx-markdown";
import { AppRoutingModule } from "./app/app-routing.module";
import { AppComponent } from "./app/app.component";
import { CustomErrorHandler } from "./app/shared/exceptions/custom-error-handler";
import { appReducer } from "./app/shared/store/app.state";
import { ApplicationEffects } from "./app/shared/store/application/application.effects";
import { QuoteEffects as TermLifeInsuranceQuoteEffects } from "./app/shared/store/quote/term-life-insurance/quote.effects";
import { environment } from "./environments/environment";

if (environment.environment !== "local") {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(),
    // Since this is a experimental feature, we need to keep track on how it behaves and remove it if it causes any issues
    provideExperimentalZonelessChangeDetection(),
    importProvidersFrom([
      AppRoutingModule,
      MarkdownModule.forRoot(),
      BrowserAnimationsModule,
    ]),
    {
      provide: ErrorHandler,
      useClass: CustomErrorHandler,
    },
    provideStore(appReducer),
    provideStoreDevtools({
      maxAge: 25, // Retains last 25 states
      logOnly: !isDevMode(), // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
      trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
      traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided with true)
      connectInZone: true, // If set to true, will broadcast state changes only inside Angular zone
    }),
    provideEffects(
      // Quote
      TermLifeInsuranceQuoteEffects,
      // Application
      ApplicationEffects,
    ),
  ],
}).catch((err: unknown) => {
  console.error(err);
});
